import {RestResource} from '../rest'
import {EQUIPMENT_IN_OUT_SERVER} from '../server'

const equipmentIoInfo = new RestResource({server: EQUIPMENT_IN_OUT_SERVER, resource: 'equipmentioinfo'});

export default equipmentIoInfo;